import { lazy } from "react";

export { OVERDUE_TASKS_NOTIFICATION_SETTINGS_PATH } from "./path";
export const OverdueTasksNotificationSettingsPage = lazy(
  () => import("./page"),
);
